module.exports = __webpack_public_path__ + "static/media/laptop-with-image.6ef6041f.png";